export default class ContractPlan {
  id: string;

  externalId: string;

  name: string;

  activated: boolean;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.externalId = obj.externalId || '';
    this.name = obj.name || '';
    this.activated = obj.activated === undefined ? true : obj.activated;
  }

  public static of(obj: any): ContractPlan {
    return new ContractPlan(obj);
  }

  public static ofList(obj: any[]): ContractPlan[] {
    return obj.map(this.of)
  }

  get status(): string {
    return this.activated ? 'ativo' : 'inativo';
  }

  get isActivated(): boolean {
    return this.activated;
  }
}
